import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { BankAccountType } from '@debbie/common/dist/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import * as creditorsAPI from '@debbie/cortex/dist/api/creditors.js';
import { Button, SmallHeader } from '../index.js';
import THEME from '../../theme.js';
import BankAccountInput from '../economy/BankAccountInput.js';
import { creditorsEntity, useCreditor } from '@debbie/cortex/dist/creditors/index.js';
import keys from '@debbie/common/dist/cache/keys.js';
import q from '@debbie/cortex/dist/query.js';
const BankAccountDetails = (props) => {
    const { creditorId } = props;
    const lang = useSelector((s) => s.lang);
    const creditorLoadable = useCreditor(creditorId);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    const [loading, setLoading] = useState(false);
    const [bankAccount, setBankAccount] = useState(['', '']);
    useEffect(() => {
        if (creditor &&
            creditor.bankAccountDetails &&
            creditor.bankAccountDetails.accountNumber &&
            creditor.bankAccountDetails.registrationNumber) {
            setBankAccount([
                creditor.bankAccountDetails.registrationNumber,
                creditor.bankAccountDetails.accountNumber,
            ]);
        }
    }, [creditor]);
    const updateBankAccountDetails = async () => {
        if (!creditorId)
            return;
        setLoading(true);
        try {
            await creditorsAPI.update(creditorId, {
                bankAccountDetails: bankAccount[0]
                    ? {
                        type: BankAccountType.Danish,
                        registrationNumber: bankAccount[0],
                        accountNumber: bankAccount[1],
                    }
                    : null,
            });
            q.invalidate(keys.write.modify(creditorsEntity, creditorId));
        }
        catch (err) {
            alert('Error');
        }
        setLoading(false);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(SmallHeader, null, lang.creditors.bankAccountDetails),
        React.createElement("div", { style: { display: 'flex', alignItems: 'flex-start' } },
            React.createElement(BankAccountInput, { value: bankAccount, onChange: (bankAccount) => {
                    setBankAccount(bankAccount);
                } }),
            creditor &&
                !((!bankAccount[0] &&
                    !bankAccount[1] &&
                    !creditor.bankAccountDetails) ||
                    (bankAccount[0] ==
                        creditor.bankAccountDetails?.registrationNumber &&
                        bankAccount[1] == creditor.bankAccountDetails?.accountNumber)) && (React.createElement(Button, { loading: loading, disabled: !((!bankAccount[0] && !bankAccount[1]) ||
                    (`${bankAccount[0]}`.length === 4 &&
                        `${bankAccount[1]}`.length > 5 &&
                        `${bankAccount[1]}`.length < 11)), onClick: updateBankAccountDetails, style: { marginLeft: `${THEME.GRID_SPACING}px` } }, lang.creditors.updateBankAccountDetails)))));
};
export default BankAccountDetails;
//# sourceMappingURL=BankAccountDetails.js.map